import { useQuery } from '@tanstack/react-query'

import { cepIntegrationsKeys } from 'common/api/queryKeys/integrationsKeys'
import { useAppSelector } from 'common/hooks/redux'

import { getIntegrationByIntegrationId } from '../api'

const useGetIntegrationByIdQuery = (integrationId: string | undefined) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const getIntegrationsQuery = useQuery({
    queryKey: cepIntegrationsKeys.getIntegrationById(integrationId!),

    queryFn: () =>
      getIntegrationByIntegrationId({
        integrationId: integrationId!,
        accountId,
      }),
    select: (data) => {
      return {
        credentials: data.credentials,
      }
    },
    enabled: !!integrationId,
    gcTime: 0,
    staleTime: 0,
  })
  return getIntegrationsQuery
}

export default useGetIntegrationByIdQuery
